import { createAction } from 'redux-actions';
import { PapiGallection } from '@wix/da-papi-types';

export const fetchBreadcrumbs = createAction(
  'STASH.FETCH_BREADCRUMBS',
  (folder: PapiGallection) => ({ folder })
);

export const setBreadcrumbs = createAction(
  'STASH.SET_BREADCRUMBS',
  (breadcrumbs: PapiGallection[]) => ({ breadcrumbs })
);
